var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"data-popup-modal","hide-footer":"","centered":"","title":_vm.modalTitle}},[(_vm.dataset_type === 'exo3')?_c('cast-s4o'):_vm._e(),(_vm.dataset_type === 'exo-full')?_c('cast-exo-full'):_vm._e(),(_vm.dataset_type === 'ctd-o2-chlora')?_c('cast-ctd'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }